module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    },
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "prologue-1"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("To whoever wanted to listen, Jan told stories about the places on the other side of the world. Tasman had named the land where they spent ten days Van Diemen’s Land, after the Governor in Batavia. Much further east, he named a new land New Zealand, after Zeeland, the Dutch province that had helped to pay for the expedition. Tasman had named many other places; Jan said that new maps of the world would show a trail of his travels.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("One of the few persons who really wanted to hear all of what he had to tell was a farmer’s daughter named Heyle, whom he married so she could lie in his arms on long winter nights. She enjoyed all his stories but what she liked most was to imagine the southern night skies that he painted in words – the clarity of the swirls of stars, some forming a cross that always pointed south; what could be the portent of that? And then there were the dancing drapes of southern lights that, Jan said, showed the colours of mother of pearl – she shivered at the thought of such celestial wonders. At other times, when Jan had finished a story and the night was still young, Heyle would ask him what it was that made him spend all his money in Amsterdam. “Tell me,” she would whisper in his ear, “because anything they did, I will do better.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("When Jan became an old man, the only one who would still listen to his stories was his nephew Harman Claesen Bolt. Although Jan did not write easily, he had penned an account of his journey to the bottom of the world. When it was on paper, he opened the box, rolled the paper around the twig with the leaves and the pods, and put the bundle in the box. It just fitted. Jan smelled the fragrance of the distant shore once more. He then closed the box and gave it to his nephew Harman. “Look after it,” Jan had said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The young Harman was a farmer but one with an unusual interest in reading, so the Dutch Reformed Church in Ten Boer asked him to help in sorting out old papers about floods. Harman saw records of floods that overran the province in 1570, and again in 1686. As a farmer, he was responsible for maintaining the part of the dike adjoining his land. However, not every farmer did the same. Harman had supported a new provincial inspector who warned that, if no action was taken, there would be trouble ahead. His predictions had been ridiculed, ostensibly because the official, Thomas van Seeratt, was from Sweden, so what did he know about dikes? In truth, it was because Thomas called for urgent improvements to the dikes and more provincial control. However, people had preferred to keep their money in their pockets, and to do nothing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The flood came on the night of Christmas in 1717. That day, a north westerly gale had developed into a big storm. The wind drove water levels up and up in the Wadden Sea. From northern Holland to the coast of Denmark, all land adjacent to the Wadden Sea was inundated. People and cattle drowned by tens of thousands. In Groningen, water reached inland as far as the ramparts of the city. In the province, more than two thousand people and thirty-five thousand farm animals died. Over fifteen hundred houses")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba589114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0012.vue
// module id = 96
// module chunks = 0